import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faWhatsapp
} from "@fortawesome/free-brands-svg-icons"
const Header = () => {
  return (
    <>
    <div className="chat">
    <a href="https://chatwith.io/s/6062a876153c9" className="text-white" target="blank"><FontAwesomeIcon className="bg-transparent mt-0" icon={faWhatsapp} size="2x"  role="button" aria-label="Whatsapp"/></a>
    </div>
    </>
  )
}

export default Header;
